import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';

type Flags = {
  showDataUploadCounts: boolean;
  flagEnabledMeetings: boolean;
  flagEnabledLexicalEditor: boolean;
  flagEnabledProviderSources: boolean;
  flagEnabledRemoveDynamicUi: boolean;
  flagEnabledComplianceChecking: boolean;
  flagEnabledDocumentEdit: boolean;
};

export function useFlags() {
  return useLDFlags<Flags>();
}
